<template>
    <div @click="handleClickEvent" ref="target">
        <component :is="getItemComponent()" :tour="tour" :url="url" :loading="loading" :layout="layout"
            :hide-cta="hideCta" :priority="priority" v-model:height="height" />
    </div>
</template>

<script setup lang="ts">
import { Tour } from "@/types";
import { onMounted } from "vue";

// Island Routes Tour Item Components
import IrGridItem from "@/Components/Tour/Item/IslandRoutes/GridItem.vue";
import IrListItem from "@/Components/Tour/Item/IslandRoutes/ListItem.vue";

// Jamaica Tours Tour Item Components
import JamaicaToursItem from "@/Components/Tour/Item/JamaicaTours/ListItem.vue";
import { useSetting } from "@/Hook/useSetting";
import { useImpressionObserver } from "@/Hook/useImpressionObserver";

const height = defineModel<number>('height')

const emit = defineEmits(['click', 'impression'])

const { target } = useImpressionObserver(function (entry) {
    emit('impression', entry)
})

const { layout } = defineProps<{
    url?: string;
    tour: Tour;
    layout?: "grid" | "list";
    loading?: boolean;
    hideCta?: boolean;
    // Above-the-fold card: eager-load its image so it is a valid LCP candidate.
    priority?: boolean;
}>();


const handleClickEvent = function () {
    emit('click')
}

const getItemComponent = function () {
    const { getSetting } = useSetting();

    let component = null;

    let component_key =
        layout == "grid"
            ? "tours_grid_item_component"
            : "tours_list_item_component";



    switch (getSetting(component_key)) {
        case "jamaica-tours":
            component = JamaicaToursItem;
            break;

        default:
            component = layout == "grid" ? IrGridItem : IrListItem;
            break;
    }

    return component;
};

onMounted(getItemComponent);
</script>
